const wrapper = "_35sw8isw7y";
const list = "_35sl1gj01my";
const scrollArrow = "_35ss1b0zw6x";

export { list, scrollArrow, wrapper };
import "./_bullets.style.linaria.module.css";
//# sourceMappingURL=_bullets.style.js.map
